import { isDevMode } from '@angular/core';
import { TranslocoHttpLoader } from './translation-loader';

export const translocoConfig = {
  config: {
    availableLangs: ['nl'],
    defaultLang: 'nl',
    fallbackLang: 'nl',
    reRenderOnLangChange: true,
    prodMode: !isDevMode(),
    missingHandler: {
      allowEmpty: true,
      useFallbackTranslation: true,
    },
  },
  loader: TranslocoHttpLoader,
};
